// store/modules/notificaciones.js
const state = {
  snackbar: {
    show: false,
    text: '',
    color: 'success',
    timeout: 3000,
    icon: '',
    button: false,
    textButton: '',
    top: true,
    right: true,
    action: null,
  },
};

const mutations = {
  SHOW_SNACKBAR(state, payload) {
    state.snackbar = { ...state.snackbar, ...payload, show: true };
  },
  HIDE_SNACKBAR(state) {
    state.snackbar.show = false;
  },
};

const actions = {
  showSnackbar({ commit }, payload) {
    commit('SHOW_SNACKBAR', payload);
  },
  hideSnackbar({ commit }) {
    commit('HIDE_SNACKBAR');
  },
};

const getters = {
  snackbar: (state) => state.snackbar,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
